(() => {
  const init = (root) => {
    if (!root || !root.matches('[data-tan-member-journey]') || root.dataset.memberJourneyReady) return;
    root.dataset.memberJourneyReady = 'true';

    const preview = root.querySelector('[data-member-wall-preview]');
    const choices = Array.from(root.querySelectorAll('[data-member-zone-choice]'));
    const ambient = root.querySelector('[data-member-ambient]');
    const ambientValue = root.querySelector('[data-member-ambient-value]');
    const resultHeading = root.querySelector('[data-member-zone-heading]');
    const resultCopy = root.querySelector('[data-member-zone-copy]');
    const resultList = root.querySelector('[data-member-zone-list]');

    const updateChoice = (choice) => {
      if (!choice || !preview) return;
      choices.forEach((item) => {
        const active = item === choice;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', String(active));
      });

      preview.dataset.mode = choice.dataset.modeKey || 'reception';
      if (resultHeading) resultHeading.textContent = choice.dataset.zoneTitle || '';
      if (resultCopy) resultCopy.textContent = choice.dataset.zoneNote || '';

      const payload = root.querySelector(`[data-member-zone-payload="${CSS.escape(choice.dataset.zoneId || '')}"]`);
      const content = payload?.content.querySelector('[data-member-zone-checklist]');
      if (resultList && content) resultList.innerHTML = content.innerHTML;

      ['viewer', 'constraint', 'evidence'].forEach((metric) => {
        const label = root.querySelector(`[data-member-metric-label="${metric}"]`);
        const value = root.querySelector(`[data-member-metric-value="${metric}"]`);
        if (label) label.textContent = choice.dataset[`${metric}Label`] || '';
        if (value) value.textContent = choice.dataset[`${metric}Value`] || '';
      });
    };

    const updateAmbient = () => {
      if (!ambient || !preview) return;
      const strength = Number(ambient.value) / 100;
      preview.style.setProperty('--fitness-daylight', String(0.08 + strength * 0.52));
      preview.style.setProperty('--fitness-glow', String(0.72 + (1 - strength) * 0.28));
      preview.style.setProperty('--fitness-room-light', String(0.18 + strength * 0.62));
      if (ambientValue) ambientValue.textContent = `${ambient.value}%`;
    };

    choices.forEach((choice) => choice.addEventListener('click', () => updateChoice(choice)));
    ambient?.addEventListener('input', updateAmbient);
    updateAmbient();
  };

  const initAll = (scope = document) => {
    if (scope.matches?.('[data-tan-member-journey]')) init(scope);
    scope.querySelectorAll?.('[data-tan-member-journey]').forEach(init);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll());
  else initAll();
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
